import { useEffect } from 'react';

const Resume = () => {
    useEffect(() => {
        window.location.href = "https://drive.google.com/drive/folders/1uQkYma2wjfpyupdSbz3uycstqq-y9q4p?usp=sharing";
    }, []);

    return null;
};

export default Resume;